
export const getReplacedTemplate = (template, substitutions) => {

    if (!substitutions?.length) return template;

    let result = `${template}`;

    substitutions.forEach(s => {
        result = result.replaceAll(s.searchText, s.replaceWith);
    });

    return result;
}

export const toTitleCase = str =>{
    if (typeof str !== 'string') return '';
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};
